var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-sticky-section-edit"},[_c('div',{staticClass:"singularity-button-group"},[_c('SingularityCanvasButton',{attrs:{"icon":"EditSolidIcon","text":"Edit Section"},on:{"click":_vm.activateElement}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }